export default "__VITE_ASSET__bChIr9ju__"